export const splitFullName = (fullName: string) => {
    const nameParts = fullName.trim().split(/\s+/).filter(Boolean);
    return {
        firstName: nameParts[0] ?? "",
        lastName: nameParts.slice(1).join(" "),
    };
};
